export const GET_CLASSES_LIST_SUCCESS = 'GET_CLASSES_LIST_SUCCESS';
export const GET_CLASSES_LIST = 'GET_CLASSES_LIST';
export const GET_CLASS_APPS_SUCCESS = 'GET_CLASS_APPS_SUCCESS';
export const GET_CLASS_APPS = 'GET_CLASS_APPS';
export const SET_CLASS_LOADING = 'SET_CLASS_LOADING';
